import { useEffect, useState } from 'react';

/**
 * useLocalStorage
 * will be used to get localStorage value on server side
 * @param key String
 * @returns String
 */
export const useLocalStorage = (key) => {
  const getValue = (key) => {
    const item = localStorage.getItem(key);
    if (item && item !== 'undefined') {
      return JSON.parse(item);
    }
    return item;
  };

  const [value, setState] = useState(false);

  useEffect(() => {
    setState(getValue(key));
  }, []);

  return { value };
};
